import { render } from "./HelloWorld.vue?vue&type=template&id=43f48a4c&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=43f48a4c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43f48a4c"

export default script